// @ts-ignore esModuleInterop
import React from 'react'
// @ts-ignore no types
import { Alert, Text, utils } from '@adc/ui-adc'
// @ts-ignore no types
import { contactNumbers } from '@adc/constants'
const { formatPhoneNumber } = utils.formatters

interface AccountRestrictedAlertProps {
  shouldShowRegistrationLimitReachedMessage?: boolean
  showIcon?: boolean
}

export const AccountRestrictedAlert = ({
  shouldShowRegistrationLimitReachedMessage = false,
  showIcon = true,
  ...rest
}: AccountRestrictedAlertProps) => (
  // @ts-ignore widen types a bit in DS to not require all props that should be optional
  <Alert
    header={
      shouldShowRegistrationLimitReachedMessage
        ? 'Registration Limit Reached'
        : 'Account Restricted'
    }
    role={shouldShowRegistrationLimitReachedMessage ? 'info' : 'caution'}
    content={
      shouldShowRegistrationLimitReachedMessage ? (
        <Text color='gray'>
          Please{' '}
          <a
            target='_BLANK'
            data-elm-id='registration_limit_faq_link'
            // TODO: change this when marketing have specific link
            href='/lp/learn-more/frequently-asked-questions/'
            rel='noreferrer'
          >
            click here
          </a>{' '}
          to learn more about increasing your registration limit.
        </Text>
      ) : (
        <Text color='gray'>
          Please call{' '}
          <a href={`tel:${contactNumbers.ONLINE_BUYER_EXPERIENCE}`}>
            {formatPhoneNumber(contactNumbers.ONLINE_BUYER_EXPERIENCE)}
          </a>{' '}
          and our Buyer Experience Team will assist you.
        </Text>
      )
    }
    showIcon
    {...rest}
  />
)
